import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.js';
import { usePageTitle } from '@aco/shared';

/**
 * AuthSuccessPage — handles the redirect from /auth/google/callback (and /auth/facebook/callback).
 * URL: /auth/success?token=<accessToken>
 *
 * Captures the access token from the URL, stores it in AuthContext memory,
 * then navigates to / (lobby). The token is intentionally REMOVED from the URL
 * immediately to avoid it sitting in history.
 */
export function AuthSuccessPage() {
  usePageTitle(null, 'Signing In…');
  const [searchParams] = useSearchParams();
  const { setTokenFromRedirect } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    if (token) {
      setTokenFromRedirect(token);
    }
    // Replace history so the token URL doesn't persist in back-nav
    navigate('/', { replace: true });
  }, []); // intentionally run once on mount — token is in URL at load time

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100dvh',
        backgroundColor: '#0f1117',
        color: '#ffffff',
        fontFamily: 'system-ui, sans-serif',
        fontSize: '1.1rem',
      }}
    >
      Signing you in…
    </div>
  );
}
